import React from "react";
import { FormControl } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import moment from 'moment';
import context from "./../lib/context.js";
import AccrualByPlacement from "./accrual/accrual-by-placement.jsx";
import AccrualByPlacementMobile from "./accrual/accrual-by-placement-mobile.jsx";

export default class SupervisorAccrualHomeOld extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            userYearSelection: "CURRENT",
        }
        this.handleyearChange = this.handleyearChange.bind(this);
        this.loadGrid = this.loadGrid.bind(this);
        this.isAndroid = this.isAndroid.bind(this);
        this.isIos = this.isIos.bind(this);
    }
    handleyearChange(event) {
        let value = event.target.value;
        this.loadGrid(value);
    }
    loadGrid(period) {
        let self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });
        ajax.vm()
            .get(`supervisor/get-accrual-summary/0/${period}`) // passing zero to API will compel to use current approver Id
            .then(function (res) {
                const result = res.data;
                self.setState({
                    items: result,
                    userYearSelection: period
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                self.setState({
                    items: [],
                    userYearSelection: period
                });
                let data = err.response ? err.response.data : err;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }
    componentDidMount() {
        this.loadGrid(this.state.userYearSelection);
    }
    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        let mobile = this.isIos() || this.isAndroid();
        if (this.state.items.length > 0) {
            if (mobile) {
                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <h2 className="text-center ap-title-mobile">PTO/Sick Leave Balance</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <FormControl componentClass="select" defaultValue={this.state.userYearSelection} onChange={this.handleyearChange}>
                                    <option key="CURRENT" value="CURRENT"> Current Anniversary Year</option>
                                    <option key="PRIOR" value="PRIOR"> Previous Anniversary Year </option>
                                </FormControl>
                            </div>
                        </div>
                        <AccrualByPlacementMobile items={this.state.items} />
                    </div>
                );
            } else {
                return (
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="text-center ap-title">PTO/Sick Leave Balance</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <FormControl componentClass="select" defaultValue={this.state.userYearSelection} onChange={this.handleyearChange}>
                                    <option key="CURRENT" value="CURRENT"> Current Anniversary Year</option>
                                    <option key="PRIOR" value="PRIOR"> Previous Anniversary Year </option>
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <AccrualByPlacement items={this.state.items} />
                            </div>
                        </div>
                    </div>
                );
            }
        } else {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="text-center ap-title">PTO/Sick Leave Balance</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 ap-accrualgrid-empty">
                            No Details found !
                        </div>
                    </div>
                </div>
            );
        }

    }
}
